/**
 * SKU表单验证规则
 * 职责: 定义表单字段验证逻辑
 * 限制: <50行
 */

export const skuFormRules = {
    name: [
        { required: true, message: '请输入SKU名称' }
    ],
    asin: [
        { required: true, message: '请输入ASIN' },
        { len: 10, message: 'ASIN必须是10位字符' }
    ],
    price: [
        {
            validator: (_: any, value: any) => {
                if (!value) return Promise.resolve();
                const numValue = typeof value === 'string' ?
                    parseFloat(value) : value;
                if (isNaN(numValue)) return Promise.resolve();
                if (numValue < 0) {
                    return Promise.reject(new Error('售价不能为负数'));
                }
                return Promise.resolve();
            }
        }
    ],
    profit_margin: [
        {
            validator: (_: any, value: any) => {
                if (!value) return Promise.resolve();
                const numValue = typeof value === 'string' ?
                    parseFloat(value) : value;
                if (isNaN(numValue)) return Promise.resolve();
                if (numValue < 0 || numValue > 100) {
                    return Promise.reject(
                        new Error('利润率范围0-100%')
                    );
                }
                return Promise.resolve();
            }
        }
    ]
};
